(ns manatee.annotation.view
  (:require [clojure.string :as str]
            [manatee.admin.task-config.subs :as task-config-subs]
            [manatee.annotation.components :as components]
            [manatee.annotation.handlers :as handlers]
            [manatee.annotation.subs :as annotation]
            [manatee.components.item :as annotation-item]
            [manatee.components.modal.handlers :as modal]
            [manatee.domain.task :as task]
            [manatee.models.item :as item-model]
            [manatee.ui.templates :as templates]
            [manatee.user.subs :as user-subs]
            [re-frame.core :as rf]
            [reagent.core :as reagent]
            [rothko.button.component :refer [button]]
            [rothko.footer.component :as rothko-footer]))

(defmethod item-model/annotation-view
  :default
  [{:keys [task-config-id] :as item} & _]
  (let [{:keys [queue-name] :as task-config} @(rf/subscribe [::task-config-subs/task-config task-config-id])
        show-ai-hybrid? (task/modifier task-config :show-ai-hybrid?)]
    [:div.annotation__view
     [:div [:span "Queue — " queue-name]]
     (cond-> [annotation-item/annotate-item item {}]
       show-ai-hybrid?
       (conj [components/ai-hybrid-checkbox false]))
     [components/display-raw-item-data task-config item]]))

(defn view
  [{:keys [class item]}]
  [:div {:class class}
   [components/alert-container]
   [components/submit-item-modal]
   [components/reject-item-modal item]
   [components/report-item-modal item]
   [components/notes-modal item]
   [components/metadata-modal item]
   (item-model/annotation-view item)])

(defn container
  []
  (reagent/create-class
   {:display-name "annotation-view"
    :component-did-mount #(rf/dispatch [::handlers/focus-current-item])
    :component-did-update #(rf/dispatch [::handlers/focus-current-item])
    :reagent-render (fn [props]
                      (let [loading? @(rf/subscribe [::annotation/loading?])
                            current-item @(rf/subscribe [::annotation/current-item])
                            current-notes @(rf/subscribe [::annotation/current-notes])]
                        [view (assoc props :item (if loading?
                                                   {:view-state :loading}
                                                   (cond-> current-item
                                                     (not (str/blank? current-notes))
                                                     (assoc :current-notes current-notes))))]))}))

(defn footer []
  (let [{:keys [feedback? item-type item-task task-config-id view-state] :as item} @(rf/subscribe [::annotation/current-item])
        user @(rf/subscribe [::user-subs/user])
        suppress-part-screen? @(rf/subscribe [::annotation/suppress-part-screen?])
        part-like? @(rf/subscribe [::annotation/part-like? item-type])
        task-config @(rf/subscribe [::task-config-subs/task-config task-config-id])
        allow-reports? (task/modifier task-config :allow-reports?)
        allow-deferments? (task/modifier task-config :allow-deferments?)
        allow-going-back? (task/modifier task-config :allow-going-back?)
        allow-notes? (task/modifier task-config :allow-notes?)
        notes @(rf/subscribe [::annotation/current-notes])
        incomplete-feedback? @(rf/subscribe [::annotation/incomplete-feedback?])
        unannotated-answers @(rf/subscribe [::annotation/unannotated-items-by-type :answer])
        enabled? (not (or (contains? #{:loading :no-items} view-state)
                          @(rf/subscribe [::annotation/loading?])))]
    (when enabled?
      [rothko-footer/footer
       {:appearance #{:primary :sticky}
        :content [(when (not part-like?)
                    [components/back-button])
                  (when (:is-evaluator user)
                    [button {:appearance #{:secondary :full-width}
                             :on-click #(rf/dispatch [::handlers/ignore-item {:user-id (:id user)}])}
                     "Ignore"])
                  (when (= :multi-marking-202006 item-task)
                    [button {:appearance #{:secondary :full-width}
                             :on-click #(rf/dispatch [::modal/show :metadata-modal])}
                     "Difficult to mark"])
                  (when (and allow-going-back?
                             part-like?)
                    [button {:appearance #{:secondary :full-width}
                             :on-click #(rf/dispatch [::handlers/load-previous-items])}
                     "Previous"])
                  (when (and (not feedback?)
                             (= :answer item-type)
                             allow-reports?)
                    [button {:appearance #{:secondary :full-width}
                             :on-click #(rf/dispatch [::modal/show :report-item-modal])}
                     "Report"])
                  (when allow-notes?
                    [button {:appearance #{:secondary :full-width}
                             :on-click #(rf/dispatch [::modal/show :notes-modal])}
                     (if (str/blank? notes) "Add Note" "Edit Note")])
                  (when (and (not feedback?)
                             part-like?
                             allow-deferments?)
                    [button {:appearance #{:secondary :full-width}
                             :on-click #(rf/dispatch [::handlers/defer-item {:user-id (:id user)}])}
                     "Defer"])
                  (when (-> task-config (get-in [:data item-type :rejections :reasons]) seq)
                    [button {:appearance #{:secondary :full-width}
                             :on-click #(rf/dispatch [::handlers/show-reject-item-modal item])}
                     (let [custom-label (get-in task-config [:data item-type :rejections :button-label])
                           label (or custom-label "Reject ")]
                       (str label (when (and item-type
                                             (not suppress-part-screen?)
                                             (not custom-label))
                                    (name item-type))))])
                  (when (not (true? (task/modifier task-config :hide-submit?)))
                    [button {:appearance #{:primary :full-width}
                             :id :submit-annotation
                             :on-click #(rf/dispatch [::handlers/submit-annotation item task-config incomplete-feedback? unannotated-answers])}
                     (let [custom-label (get-in task-config [:data item-type :submit-button-label])]
                       (or custom-label "Submit"))])]}])))

(def page
  {:footer footer
   :main container
   :template templates/single-column})
